module.exports = __webpack_public_path__ + "static/media/office-365.ae7c100f.svg";